
import {Constants} from './../cc-imports'

import _ from 'lodash';

const _MS_PER_DAY = 1000 * 60 * 60 * 24;
const _MS_PER_HOUR = 1000 * 60 * 60 ;
const _MS_PER_MINUTE = 1000 * 60 ;
const _MS_PER_SECONDS = 1000 ;

const CCUtils = {

    userUpdated(props1, props2){
        if(props1.anonymous!=props2.anonymous){
            return true;
        }
        var user1 = props1.user;
        var user2 = props2.user;
        var u1Defined = user1!=null && user1!=undefined;
        var u2Defined = user2!=null && user2!=undefined;

        if((u1Defined && !u2Defined) || (!u1Defined && u2Defined)){
            return true;
        }

        if(u1Defined && u2Defined){
            return user1.id!=user2.id || user1.country!=user2.country;
        }

        return false;
    },

    attachNetworkListener(actions){

    },

    formatTime(createdDate) {
        var time = "";
        var createdTime = new Date(createdDate);
        var now = new Date();

        var diffMins = (now.getTime() - createdTime.getTime() ) / 60000;

        if (diffMins <= 10) {
            time = "Now";
        }
        else if (diffMins <= 1440) {
            time = createdTime.toLocaleTimeString("en-US", {
                hour: '2-digit',
                minute: '2-digit'
            });
        }
        else {
            time = createdTime.toLocaleDateString("en-US", {
                day: '2-digit',
                year: '2-digit',
                month: '2-digit',
            });
        }
        return time;
    },

    formatDate(date) {
        if(!date){
            return '';
        }

        var createdTime = new Date(date);
        var time = createdTime.toLocaleDateString("en-US", {
            day: '2-digit',
            year: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
        return time;
    },
    
    getSignInError(err, providers, type, value){
        err.providers = providers;
        switch (type) {
            case 'password':
                err.emailCredentials = value;
                break;
            case 'google':
                err.googleCredentials = value;
                break;
            case 'facebook':
                err.fbCredentials = value;
                break;
        }
        return err;
    },
    getDoNotShowAgainMessage(){

    },


    groupByGetIds(xs, key, key2){
        if(xs===null||xs===undefined){
            return {};
        }
        return xs.reduce(function (rv, x) {
            if (key2) {
                (rv[x[key][key2]] = rv[x[key][key2]] || []).push(x.id);
            }
            else {
                (rv[x[key]] = rv[x[key]] || []).push(x.id);
            }
            return rv;
        }, {});
    },
    merge(o1, o2) {
        for (var prop in o2) {
            o1[prop] = o1[prop] ? _.union( o2[prop], o1[prop]) : o2[prop]
            //o1[prop] ? o1[prop].concat(o2[prop]) : o1[prop] = o2[prop];
        }
        return o1;
    },
    customArrMerger(objValue, srcValue){
        if (_.isArray(objValue)) {
            return _.union(objValue, srcValue);
        }
    },

    isLeagueCompleted(league){
        return league.status.status===Constants.leagueStatus.COMPLETED || league.status.status===Constants.leagueStatus.REFUNDED || league.status.status===Constants.leagueStatus.REFUNDED_NO_ENOUGH_PLAYERS;
    },

    getDateDiff(a, b) {
        var utc1 = a.getTime();
        var utc2 = b.getTime();
        var negative = false;

        if (utc2 > utc1) {
            negative = true;
            var temp = utc1;
            utc1 = utc2;
            utc2 = temp;
        }

        var diff = utc1 - utc2;
        var diffO = {};

        diffO.days = Math.floor(diff / _MS_PER_DAY);
        diff = diff - diffO.days * _MS_PER_DAY;
        diffO.hours = Math.floor(diff / _MS_PER_HOUR);
        diff = diff - diffO.hours * _MS_PER_HOUR;
        diffO.minutes = Math.floor(diff / _MS_PER_MINUTE);
        diff = diff - diffO.minutes * _MS_PER_MINUTE;
        diffO.seconds = Math.floor(diff / _MS_PER_SECONDS);

        if (negative) {
            diffO = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }
        return diffO;
    },

    isLoggedIn(user){
        if(user && user.id){
            return true;
        }
        return false;
    },

    sortLbs : (lbs)=>{
        _.forEach(lbs, (lb)=>{
            var up={};
            switch (lb.type){
                case Constants.lbType.DAILY:
                    up.priority=1;
                    break;
                case Constants.lbType.WEEKLY:
                    up.priority=2;
                    break;
                case Constants.lbType.MONTHLY:
                    up.priority=3;
                    break;
                default:
                    up.priority=4;
            }

            switch (lb.subType){
                case Constants.lbSubType.NO_OF_COINS_EARNED:
                    up.priority2=0;
                    break;
                case Constants.lbSubType.NO_OF_ENTRIES_PLAYED:
                    up.property2=1;
                    break;
                case Constants.lbSubType.WIN_LOST_RATIO:
                    up.property2=2;
            }

            if(lb.country==='ALL'){
                up.priority3=1;
            }
            else {
                up.priority3=0;
            }

            switch (lb.status){
                case Constants.lbStatus.ACTIVE:
                    up.priority4=0;
                    break;
                case Constants.lbStatus.COMPLETED:
                    up.priority4=1;
                    break;
                case Constants.lbStatus.ARCHIVED:
                    up.priority4=2;
                    break;

                default:
                    up.priority4 = 3;
            }

            _.merge(lb, up);
        })

        var srtdLbs = _.orderBy(lbs, ['priority', 'priority2', 'priority3', 'priority4']);
        return srtdLbs;
    }
};

export {CCUtils};


// WEBPACK FOOTER //
// ./src/app/lib/CCUtils.js